import { D2DOrderSource } from '@ecomm/door-to-door-constants/d2dOrderSource'
import { useCartCustomFields } from './useCartCustomFields'

/**
 * Returns whether cart is a door-to-door cart based on "orderSource" custom field
 */
export const useIsD2DCart = () =>
  useCartCustomFields()['orderSource'] === D2DOrderSource
